import React from 'react';
import Register from './containers/Register';

function Index(props: any) {
    return (
        <Register />
    );
}

export default Index;